<template>
  <div class="crew-plant-mobile-list">
    <div
      v-for="group in groupedByDate"
      :key="group.date"
      class="crew-plant-card"
    >
      <div class="crew-plant-card-date">{{ formatDate(group.date) }}</div>
      <div class="readonly-plant-list">
        <div
          v-for="(pe, i) in group.entries"
          :key="pe.id || `new-${i}`"
          class="readonly-plant-line"
        >
          {{ pe.plant_name
          }}<span v-if="pe.plant_id_rego" class="crew-plant-rego">
            ({{ pe.plant_id_rego }})</span
          >
          <template v-if="showCost && pe.rate_snapshot != null">
            · {{ pe.quantity }} × ${{ formatCurrency(pe.rate_snapshot)
            }}{{ pe.rate_type_snapshot === 'hourly' ? '/hr' : '/day' }} = ${{
              formatCurrency(pe.claim_value)
            }}
          </template>
          <span v-else-if="showCost" class="text-muted"
            >· qty {{ plantEntryQtyLabel(pe) }} (pending save)</span
          >
          <span v-else>· qty {{ plantEntryQtyLabel(pe) }}</span>
          <b-badge
            v-if="pe.is_amended"
            variant="warning"
            pill
            class="ml-1 plant-amended-badge"
          >
            Amended ×{{ pe.amendment_count }}
          </b-badge>
          <button
            v-if="editable"
            type="button"
            class="crew-plant-remove"
            aria-label="Remove"
            @click="$emit('remove', pe)"
          >
            &times;
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatCurrency, plantEntryQtyLabel } from '@/utils/timesheetHelpers'

export default {
  name: 'SupervisorCrewPlantCards',

  props: {
    entries: { type: Array, default: () => [] },
    editable: { type: Boolean, default: false },
    // See SupervisorCrewPlantPanel — supervisors never see dollar rates.
    showCost: { type: Boolean, default: true },
  },

  computed: {
    // One card per day. Sorts a copy — see SupervisorCrewPlantPanel.
    groupedByDate() {
      const groups = []
      const byDate = {}

      ;(this.entries || [])
        .slice()
        .sort((a, b) => {
          if (a.date !== b.date) return (a.date || '') < (b.date || '') ? -1 : 1
          return (a.plant_name || '') < (b.plant_name || '') ? -1 : 1
        })
        .forEach((pe) => {
          const key = pe.date || ''
          if (!byDate[key]) {
            byDate[key] = { date: key, entries: [] }
            groups.push(byDate[key])
          }
          byDate[key].entries.push(pe)
        })

      return groups
    },
  },

  methods: {
    formatCurrency,
    plantEntryQtyLabel,

    // See SupervisorCrewPlantPanel for why T00:00:00 is required.
    formatDate(date) {
      if (!date) return '-'
      return new Date(date + 'T00:00:00').toLocaleDateString('en-AU', {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/layouts/timesheet-shared';
@import '~@/assets/scss/layouts/supervisor-worker-shared';

.crew-plant-remove {
  border: 0;
  background: transparent;
  color: #adb5bd;
  font-size: 15px;
  line-height: 1;
  padding: 0 0 0 6px;
  vertical-align: middle;

  &:hover {
    color: #dc3545;
  }
}
</style>
